import store from "../store";

const links = [
  'index.html',
  'index.htm',
  'index.php',
]

function createRootRoutes() {
  return links.map(link => {
    return {
      path: '/' + link,
      redirect: {name: 'home', params: {lang: store.state.currentLocale}}
    }
  })
}

function createRoutes() {
  return links.map(link => {
    return {
      path: link,
      redirect: {name: 'home', params: {lang: store.state.currentLocale}}
    }
  })
}

export const rootRoutes = createRootRoutes()
export default createRoutes()
